import Cookies from 'js-cookie'

import * as types from '../mutation-types'

const locale = window.config?.locale

// state
export const state = {
  locale: Cookies.get('locale') || locale,
}

// getters
export const getters = {
  locale: (state) => state.locale,
}

// mutations
export const mutations = {
  [types.SET_LOCALE](state, { locale }) {
    state.locale = locale
  },
}

// actions
export const actions = {
  setLocale({ commit }, { locale }) {
    commit(types.SET_LOCALE, { locale })

    Cookies.set('locale', locale, { expires: 365 })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}